import React, { useEffect, useState } from "react"
import Accordion from "@mui/material/Accordion"
import AccordionSummary from "@mui/material/AccordionSummary"
import AccordionDetails from "@mui/material/AccordionDetails"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import Buttons from "@mui/material/Button"
import { styled } from "@mui/material/styles"
import { getAllChemoOrders } from "../../../../core/services/api"
import Toast from "../../../Toast"
import AccordianOrderDetail from "./AccordianOrderDetail"
import EditIcon from "@mui/icons-material/Edit"
import AddNewChemoOrder from "./AddNewChemoOrder"
import "./AccordianPrint.scss"
import moment from "moment"
import AddNewChemoOrderWS from "./AddNewChemoOrderWS"



const CustomAccordion = styled(Accordion)(({ theme }) => ({
  backgroundColor: "#AFC4FF",
  borderBottom: 0,
}))

function CompletedOrder({ patientInfo, readOnly, smartSummaryDetails, appointmentId, appointmentDetails, center }: any) {
  const [allOrders, setallOrders] = useState([])
  const [displayToast, toggleDisplayToast] = useState<any>()
  const [showForm, setshowForm] = useState<boolean>(false);
  const [refresh, setrefresh] = useState<any>(false)
  useEffect(() => {
    const event = "PAST";
    getAllChemoOrders(patientInfo?.id, event).then((res) => {
      // res?.sort((a: any, b: any) => new Date(b?.chemoOrderForDate)?.getTime() - new Date(a?.chemoOrderForDate)?.getTime());
      setallOrders(res)
    })
  }, [refresh])


  return (<div
    style={readOnly ? { cursor: 'not-allowed' } : {}}
    className="completed-chemo" >
    {/* <div className="create-heading" style={{ paddingBottom: "20px" }}>
        Create Chemo order for date
      </div> */}
    {allOrders?.map((values: any, index: any) => {
      return (
        <CustomAccordion
          sx={{
            "&:before": {
              display: "none",
            },
            // borderRadius: "20px",
            // margin: "20px",
            marginTop: "10px",
            borderRadius: "10px",
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <div className="accordian-heading">
              <div className="accordian-child">Chemo Order</div>
              <div className="accordian-child">cycle {values?.cycleNo}</div>
              <div className="accordian-child">{values?.regimen}</div>
              <div className="accordian-child">
                {values?.chemoOrderForDate ? moment(values?.chemoOrderForDate)?.format("DD-MM-YYYY") : "-"}
              </div>
              <div className="accordian-child">
                {patientInfo?.centers[0]?.centerName}
              </div>
              <div className="accordian-child" style={{ flex: 2 }}>
                {patientInfo?.primaryConsultantName}
              </div>

            </div>
          </AccordionSummary>
          <AccordionDetails sx={{ backgroundColor: "#f7f8fa" }}>
            <div className="edit-icon-parent">
              <div>
                {values?.isEditable === true ? (
                  <Buttons
                    variant="text"
                    sx={{
                      color: "black",

                      fontWeight: "600",
                    }}
                    onClick={(event: any) => {
                      event.stopPropagation();
                      setshowForm((current) => !current);
                    }}
                    startIcon={<EditIcon sx={{ color: "black" }} />}
                  ></Buttons>
                ) : (
                  <></>
                )}
              </div>
            </div>
            {
              (values?.isActive || values?.isCompleted) && (
                <div className="chemo-details-row1">
                  <div className="accordian-details-sub">
                    <div className="details-general-sub-label">Appointment ID:</div>
                    <div className="details-general-sub-value">{appointmentDetails?.mocAppointmentId}</div>
                  </div>
                </div>
              )
            }
            {showForm ? (
              <div>
                {
                  center && center?.isWondersoftEnabled ?
                    <AddNewChemoOrderWS
                      patientInfo={patientInfo}
                      order={values}
                      isEditableOrder={values.isEditable}
                      readOnly={readOnly}
                      smartSummaryDetails={smartSummaryDetails}
                      appointmentId={appointmentId}
                      appointment={appointmentDetails}
                      redirectPendingOrder={(val: any) => {
                        //setValue(val);
                      }}
                      handleChemoOrderUpdation={(val: any) => {
                        console.log(val, "val in Pending Order ");
                        setrefresh((val: any) => !val);
                      }}
                      pendingOrDelete={true}
                    /> :
                    <AddNewChemoOrder
                      patientInfo={patientInfo}
                      order={values}
                      isEditableOrder={values.isEditable}
                      readOnly={readOnly}
                      smartSummaryDetails={smartSummaryDetails}
                      appointmentId={appointmentId}
                      appointment={appointmentDetails}
                      redirectPendingOrder={(val: any) => {
                        //setValue(val);
                      }}
                      handleChemoOrderUpdation={(val: any) => {
                        console.log(val, "val in Pending Order ");
                        setrefresh((val: any) => !val);
                      }}
                      pendingOrDelete={true}
                    />
                }
              </div>
            ) : (
              <div>
                <AccordianOrderDetail
                  patientInfo={patientInfo}
                  values={values}
                  isActive={values.isActive}
                  appointmentDate={appointmentDetails?.scheduleDate}
                  handleChemoOrderCompletion={(val: any) => {
                    setrefresh((val: any) => !val);
                  }}
                  type="PAST"
                  smartSummaryData={smartSummaryDetails}
                />
              </div>
            )}
          </AccordionDetails>
        </CustomAccordion>
      )
    })}
    {displayToast && (
      <Toast
        textMessage={displayToast}
        onClose={() => {
          toggleDisplayToast(false)
        }}
        onCloseText="Close"
        onClickText={null}
      />
    )}

  </div>
  )

}


export default CompletedOrder
